import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { breakpointSelector } from 'selectors';

import ProgressBarModifyReturn from './ProgressBar';

const ProgressBarModifyReturnContainer = (props) => {
  const breakPoint = useSelector(breakpointSelector);
  const navigate = useNavigate();

  return (
    <ProgressBarModifyReturn
      {...{
        breakPoint,
        navigate,
        ...props,
      }}
    />
  );
};

export default ProgressBarModifyReturnContainer;
